<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_i"></a><span class="strong">THE BALLAD OF DOROTHY WORDSWORTH</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle001.vue?f595640e